import { render, staticRenderFns } from "./list.vue?vue&type=template&id=b3c979ce&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=b3c979ce&prod&lang=css&"
import style1 from "./list.vue?vue&type=style&index=1&id=b3c979ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c979ce",
  null
  
)

export default component.exports